import { render, staticRenderFns } from "./syllogePage.vue?vue&type=template&id=59bf04ab&scoped=true"
import script from "./syllogePage.vue?vue&type=script&lang=js"
export * from "./syllogePage.vue?vue&type=script&lang=js"
import style0 from "./syllogePage.vue?vue&type=style&index=0&id=59bf04ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf04ab",
  null
  
)

export default component.exports